import { TprCommentApiService } from './../tpr-comment-modal.service';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'tpr-add-comment',
  templateUrl: './tpr-add-comment.component.html',
})
export class TprAddCommentComponent {

  form: UntypedFormGroup = new UntypedFormGroup({
    tprToolId: new UntypedFormControl(this.tprToolId, Validators.required),
    comment: new UntypedFormControl(null, [Validators.required, Validators.maxLength(400)])
  });

  constructor(
    private readonly service: TprCommentApiService,
    private readonly dialogRef: MatDialogRef<TprAddCommentComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly tprToolId: number
  ) { }

  save() {
    this.service.createTprComment(this.tprToolId, this.form.value)
      .subscribe(() => this.dialogRef.close(true));
  }

}
